module.exports = __webpack_public_path__ + "static/media/hugo.ee10e805.png";